module.exports = __webpack_public_path__ + "img/editor.e1700295.png";